import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { SettingResponse } from '../models/setting';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class SettingsService extends BaseService {
  private settingsUrl = this.apiUrl + '/settings';

  getSettings(): Observable<SettingResponse> {
    return this.http.get<SettingResponse>(this.settingsUrl);
  }

  getSetting(id: number): Observable<SettingResponse> {
    const url = `${this.settingsUrl}/${id}`;

    return this.http.get<SettingResponse>(url).pipe(
      tap(_ => this.log(`fetched setting id=${id}`)),
      catchError(this.handleError<SettingResponse>(`getSetting id=${id}`))
    );
  }

  getSettingData(name: string): any {
    return JSON.parse(localStorage.getItem(name));
  }

  private cacheSetting(key: string, value: any) {
    // TODO: remove local storage and replace by persitant RgNx
    localStorage.setItem(key, JSON.stringify(value));

  }

  getServerVersion(): Observable<any> {
    const url = environment.serverURL + '/api/version';

    return this.http.get<any>(url);
  }
}
